function upstreamStatusFromError(error) {
  const code = error?.code;
  if (
    error?.name === "HttpError" &&
    Number.isInteger(code) &&
    code >= 400 &&
    code < 600
  ) {
    return code;
  }
  return 500;
}

const PROVIDERS = ["zoom", "google_meet"];

const COMPLETE_PATH = "/integrations/meeting-complete.html";

const MeetingIntegrations = (app) => {
  app.get("/integrations/meeting/status", async ({ res, api }) => {
    res.headers = res.headers || {};
    res.headers["Content-Type"] = "application/json; charset=utf-8";
    try {
      const response = await api("integrations/meeting/status");
      res.status = 200;
      res.body = (await response.text()) || "{}";
    } catch (e) {
      res.status = upstreamStatusFromError(e);
      res.body = JSON.stringify({
        error: e.message || "Failed to load integration status",
      });
    }
  });

  app.get(
    "/integrations/meeting/:provider/connect",
    async ({ req, res, api }) => {
      const { provider } = req.params || {};

      if (!PROVIDERS.includes(provider)) {
        res.redirect(`${COMPLETE_PATH}?connect_error=unknown`);
        return;
      }
      try {
        const response = await api(
          `integrations/meeting/${encodeURIComponent(provider)}/connect`
        );
        const data = await response.json().catch(() => ({}));
        if (!data.url) throw new Error("No authorize URL returned");
        res.redirect(data.url);
      } catch {
        res.redirect(
          `${COMPLETE_PATH}?connect_error=${encodeURIComponent(provider)}`
        );
      }
    }
  );

  app.delete(
    "/integrations/meeting/:provider/disconnect",
    async ({ req, res, api }) => {
      const { provider } = req.params || {};
      res.headers = res.headers || {};
      res.headers["Content-Type"] = "application/json; charset=utf-8";
      if (!PROVIDERS.includes(provider)) {
        res.status = 400;
        res.body = JSON.stringify({ error: "Unknown meeting provider" });
        return;
      }
      try {
        await api(
          `integrations/meeting/${encodeURIComponent(provider)}/disconnect`,
          { method: "DELETE" }
        );
        res.status = 204;
        res.body = "";
      } catch (e) {
        res.status = upstreamStatusFromError(e);
        res.body = JSON.stringify({
          error: e.message || "Failed to disconnect",
        });
      }
    }
  );
};

export default MeetingIntegrations;
